import { render, staticRenderFns } from "./newReturnCode.vue?vue&type=template&id=b01a5bc4&scoped=true"
import script from "./newReturnCode.vue?vue&type=script&lang=js"
export * from "./newReturnCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01a5bc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b01a5bc4')) {
      api.createRecord('b01a5bc4', component.options)
    } else {
      api.reload('b01a5bc4', component.options)
    }
    module.hot.accept("./newReturnCode.vue?vue&type=template&id=b01a5bc4&scoped=true", function () {
      api.rerender('b01a5bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/returnCodeActivation/component/newReturnCode.vue"
export default component.exports